var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJumperLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 625 563",
    style: {
      enableBackground: "new 0 0 625 563"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.4,317.2l-10.2,40.5c0,0,1.5,3.5,5.5,1.5s14.7-4,14.7-4s5.5-4.2,10.2,19.4s7.5,34.5,7.5,34.5l22.6,50.9l15.9,40 c0,0,11.7-2.2,5-12.9c-6.7-10.4-21.9-44.7-21.4-52.9c0.5-8.2,3-9.4,3-9.4l15.9,19.9l13.7,33.3c0,0,12.9,10.9,13.2,7 c0.5-4-10.2-21.4-10.2-21.4l-17.1-51.9l-5-17.4l-4-3.5l-2-45.7c0,0,15.6-10.9,15.2-15.6c-0.5-4.7-13.7-28.3-13.7-28.3l-5.7-6.2 l2.2,15.9l9.7,15.6c0,0-8.9,8.9-12.9,8.9s-5.7-0.5-5.7-0.5s7.5-16.6-7-20.6c-14.4-4-17.9,11.2-13.2,22.8l-23.6,7.5 c0,0,4-5.5,4-12.9C292.1,324.7,285.4,317.2,285.4,317.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "187.2,191.1 290.1,323.9 206.1,183.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.3,148.6 337.3,303.3 421.5,155.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.3,114.3 329.6,350.7 328.8,362.7 384,119.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.2,151.1 315.7,366.6 315.2,360.4 247.6,142.4  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5,118.3c0,0-22.1-0.7-39.5,26.1c0,0-21.9,13.2-25.3,41.2c-3.5,28.1,16.6,61.3,16.6,61.3s11.7-18.6,26.8-24.3 c0,0,12.9-16.4,33.3-21.9c0,0,14.7-13.2,37.8-17.4c0,0,19.4-9.7,45-6.2c0,0,22.1-6.2,42.7-7.5c0,0,19.4-10.4,41.5-8.9 c0,0,24.8-7.5,49.2-0.5c0,0,20.1-5.5,36.5,2.2c0,0,16.6-2,33,10.4c0,0,3.5-24.1,2-43c-1.2-18.6-10.2-40.7-33.8-44.2 c0,0-13.9-15.2-41.2-10.4c0,0-20.1-10.4-44.7-2.2c0,0-18.1-10.2-45.5,1.5c0,0-22.8-5-45.7,10.9c0,0-25.6-3.2-44.7,13.9 C228.7,99.7,202.6,98.4,184.5,118.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumperLoading);
export default __webpack_public_path__ + "static/media/jumperLoading.1a4f33ace36ad159419d15feb59e47d7.svg";
export { ForwardRef as ReactComponent };